// format wallet address
export const formatWalletAddress = (address) => {
  return address.slice(0, 6) + '...' + address.slice(-4);
};
